import { createRoot } from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { registerOffline } from './services/offline';
import { BankProvider } from './state/BankContext';
import { ProgressProvider } from './state/ProgressContext';
import { RouterProvider } from './state/RouterContext';
import { SettingsProvider } from './state/SettingsContext';
import { TtsProvider } from './state/TtsContext';

import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element in index.html');

/**
 * StrictMode is intentionally not used here: in development it runs effects
 * twice, which would make the app speak every question twice and push duplicate
 * history entries. Everything else in the app is written to be StrictMode-safe.
 */
createRoot(container).render(
  <ErrorBoundary>
    <SettingsProvider>
      <TtsProvider>
        <ProgressProvider>
          <BankProvider>
            <RouterProvider>
              <App />
            </RouterProvider>
          </BankProvider>
        </ProgressProvider>
      </TtsProvider>
    </SettingsProvider>
  </ErrorBoundary>,
);

// Lets the app keep working on a phone with no connection, once installed.
registerOffline();
